import axios from 'axios';
import { getApiBaseUrl } from '../config/env';
import { resolveStorefrontHostHeader } from '../config/storefrontHost';
import { modamaiTrace } from '../utils/modamaiTrace';

const API_URL = getApiBaseUrl();

const api = axios.create({
  baseURL: API_URL || '/',
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use(
  (config) => {
    if (typeof config.method === 'string' && /^get$/i.test(config.method)) {
      /** Match shop/client `api.js`: `shop-locale` → query `locale` */
      const locale =
        (typeof window !== 'undefined' &&
          (localStorage.getItem('shop-locale') || '').trim()) ||
        'en-US';
      config.params = { locale, ...config.params };
    }

    const publicStoreId = (process.env.REACT_APP_STORE_ID || '').trim();
    if (publicStoreId) {
      config.headers['X-Store-Id'] = publicStoreId;
    }

    config.headers['X-Store-Host'] = resolveStorefrontHostHeader();

    const token = localStorage.getItem('auth_token');
    if (token) {
      try {
        const parsed = JSON.parse(token);
        config.headers.Authorization = `Bearer ${parsed}`;
      } catch {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
    try {
      const u = `${config.baseURL?.replace(/\/?$/, '') || ''}${config.url || ''}`;
      modamaiTrace('axios request', {
        method: String(config.method || 'get').toUpperCase(),
        url: u,
        params: config.params,
      });
    } catch {
      modamaiTrace('axios request', { raw: config?.url });
    }
    return config;
  },
  (error) => Promise.reject(error),
);

api.interceptors.response.use(
  (response) => {
    try {
      const c = response.config;
      const u = `${c?.baseURL?.replace(/\/?$/, '') || ''}${c?.url || ''}`;
      modamaiTrace('axios response OK', {
        status: response.status,
        url: u,
      });
    } catch {
      modamaiTrace('axios response OK', { status: response.status });
    }
    return response;
  },
  (error) => {
    try {
      const c = error.config;
      const u = `${c?.baseURL?.replace(/\/?$/, '') || ''}${c?.url || ''}`;
      modamaiTrace('axios response ERROR', {
        url: u,
        status: error.response?.status,
        message: error.message,
      });
    } catch {
      modamaiTrace('axios response ERROR', { message: error?.message });
    }
    if (error.response?.status === 401) {
      localStorage.removeItem('auth_token');
      localStorage.removeItem('user');
    }
    return Promise.reject(error);
  },
);

export default api;
